import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Heart } from 'lucide-react';
import { Dropdown } from './Dropdown';

interface AboutDropdownProps {
  location: {
    pathname: string;
  };
}

export function AboutDropdown({ location }: AboutDropdownProps) {
  const isActive = ['/aktualnosci', '/historie-adopcyjne'].includes(location.pathname);

  return (
    <Dropdown 
      title={
        <div className="flex items-center gap-2">
          <BookOpen className="w-4 h-4 text-accessible-gray-700 dark:text-white/80 high-contrast:text-white" />
          <span>Fundacja Znajdki</span>
        </div>
      }
      isActive={isActive}
    >
      <div className="py-2">
        <Link 
        to="/o-nas" 
        className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
      >
        <span>O nas</span>
      </Link>
      <Link 
        to="/sprawozdania" 
        className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
      >
        <span>Sprawozdania</span>
      </Link>
      <Link 
        to="/kontakt" 
        className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
      >
        <span>Kontakt</span>
      </Link>
        <Link 
          to="/aktualnosci" 
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <span>Blog</span>
        </Link>
      </div>
    </Dropdown>
  );
}